export const RepetitionWeek = {
    FIRST: "RepetitionWeek.FIRST",
    SECOND: "RepetitionWeek.SECOND",
    THIRD: "RepetitionWeek.THIRD",
    FOURTH: "RepetitionWeek.FOURTH",
    FIFTH: "RepetitionWeek.FIFTH",
    LAST: "RepetitionWeek.LAST"
};
